import React from 'react';
import { Grid, styled } from '@mui/material';
import Color from 'color';
import { useCowbellTranslations } from '../../../../../../i18n/translations';

interface CoverageGroupHeaderProps {
  children: React.ReactNode;
}

const CoverageGroupHeader = ({ children }: CoverageGroupHeaderProps) => {
  const { t } = useCowbellTranslations('coverage');
  return (
    <GridContainer container>
      <Grid item md={4}>
        {children}
      </Grid>
      <Grid item md={2} style={{ textAlign: 'center' }}>
        <span>{t('limit')}</span>
      </Grid>
      <Grid item md={2} style={{ textAlign: 'center' }}>
        <span>{t('retention')}</span>
      </Grid>
      <Grid item md={2} style={{ textAlign: 'center' }}>
        <span>{t('waitingPeriod')}</span>
      </Grid>
      <Grid item md={2} style={{ textAlign: 'center' }}>
        <span>{t('retroActiveDate')}</span>
      </Grid>
    </GridContainer>
  );
};

export default CoverageGroupHeader;

const GridContainer = styled(Grid)(({ theme }: { theme: any }) => {
  return {
    minHeight: '3rem',
    padding: '1rem',
    margin: 0,
    backgroundColor: Color(theme.palette.background.default)
      .lighten(theme.palette.mode === 'dark' ? 0.25 : 0.02)
      .toString(),
  };
});
